import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";

import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

export default function Landing() {

    const [inputData, setInputData] = useState('');

    let history = useHistory();

    const handleInputChange = (event) => {
        var value = event.target.value;
        setInputData(value);
    }

    const searchResults = () => {
        var urlReference = inputData.replace(" ","+");
        history.push({
            pathname: '/results/keywords=' + urlReference,
            state: { data: inputData}
        })
    }

    return(
        <>
            <Navbar fixed />
            <main>
            <div className="relative pt-12 pb-32 flex content-center items-center justify-center min-h-screen-75">
            <div
                className="absolute top-0 w-full h-full bg-center bg-custom-purple"
            >
            </div>
            <div className="container relative mx-auto">
                <div className="items-center flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                    <div className="pr-12">
                    <h1 className="text-white font-semibold text-5xl">
                        Startup Name Generator
                    </h1>
                    <p className="mt-4 text-lg text-blueGray-200">
                        Generate a short, brandable business name for your startup
                    </p>
                    </div>
                    <div className="items-center flex flex-wrap" style={{paddingTop:'20px'}}>
                    <div className="w-full lg:w-8/12 ">
                        <div className="relative w-full mb-3">
                        <input
                            type="text"
                            className="border-0 px-3 py-3 text-custom-purple rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            onChange={handleInputChange}
                        />
                        </div>
                    </div>
                    <div className="w-full lg:w-3/12" >
                        <div className="relative w-full mb-3">
                        <button 
                            style={{marginTop:'3px'}}
                            className="r sm:ml-1 text-white font-bold px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 bg-custom-purple-dark uppercase text-sm shadow hover:shadow-lg"
                            type="button"
                            onClick={searchResults}
                            >
                                <a>
                                    <i class="fas fa-cog"></i> Generar
                                </a>
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div
                className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
                style={{ transform: "translateZ(0)" }}
            >
                <svg
                className="absolute bottom-0 overflow-hidden"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
                >
                <polygon
                    className="text-blueGray-200 fill-current"
                    points="2560 0 2560 100 0 100"
                ></polygon>
                </svg>
            </div>
            </div>

            <section className="pb-20 bg-blueGray-200 -mt-24">
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap">
                <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                    <div className="px-4 py-5 flex-auto">
                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                        <i className="fas fa-lightbulb"></i>
                        </div>
                        <h6 className="text-xl font-semibold">Get name ideas</h6>
                        <p className="mt-2 mb-4 text-blueGray-500">
                        Startup Name Generator generates short, catchy names. 
                        The more specific your keywords, the better the results.
                        </p>
                    </div>
                    </div>
                </div>

                <div className="w-full md:w-4/12 px-4 text-center">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                    <div className="px-4 py-5 flex-auto">
                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                        <i className="fas fa-filter"></i>
                        </div>
                        <h6 className="text-xl font-semibold">Filter Results</h6>
                        <p className="mt-2 mb-4 text-blueGray-500">
                        Decide whether you prioritize a shorter name, having a specific 
                        keyword or domain extension.
                        </p>
                    </div>
                    </div>
                </div>

                <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                        <div className="px-4 py-5 flex-auto">
                            <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                            <i className="fas fa-heart"></i>
                            </div>
                            <h6 className="text-xl font-semibold">Save your names</h6>
                            <p className="mt-2 mb-4 text-blueGray-500">
                            Our algorithm learns from the names you like, 
                            giving you better recommendations over time.
                            </p>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="flex flex-wrap items-center mt-32">
                <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                    <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                    <i className="fas fa-user-friends text-xl"></i>
                    </div>
                    <h3 className="text-3xl mb-2 font-semibold leading-normal">
                    Why a branded name?
                    </h3>
                    <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                    For new businesses, naming options can seem quite limited. Short domains are very expensive, yet longer multi-word names don’t inspire confidence.
                    In 2021 many startups are choosing a short, branded name - a name that’s unique, memorable and affordable.
                    </p>
                    <Link to="/" className="font-bold text-blueGray-700 mt-8">
                    Find a name for your startup!
                    </Link>
                </div>

                <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-custom-purple">
                    <img
                        alt="..."
                        src="https://images.unsplash.com/photo-1508849789987-4e5333c12b78?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1593&q=80"
                        className="w-full align-middle rounded-t-lg"
                    />
                    <blockquote className="relative p-8 mb-4">
                        <svg
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 583 95"
                        className="absolute left-0 w-full block h-95-px -top-94-px"
                        >
                        <polygon
                            points="-30,95 583,95 583,65"
                            className="text-custom-purple fill-current"
                        ></polygon>
                        </svg>
                        <h4 className="text-xl font-bold text-white">
                        Unique, brandable names
                        </h4>
                        <p className="text-md font-light mt-2 text-white">
                        Most business name generators combine dictionary words to make longer names.
                        Startup Name Generator generates short, branded names that are relevant to your business idea. 
                        </p>
                    </blockquote>
                    </div>
                </div>
                </div>
                </div>
                </section>
                </main>
            <Footer />
            
        </>
    )
}
